export const futureRangeNames = ['tomorrow', 'next-week'] as const
export const pastRangeNames = [
  'this-week',
  'this-month',
  'this-year',
  'last-7-days',
  'last-30-days',
  'last-month',
  'last-12-months',
  'last-year',
  'last-3-months',
  'yesterday',
  'today',
] as const

export const dateRangeNames = [...pastRangeNames, ...futureRangeNames] as const

export type PredefinedDateRange = (typeof dateRangeNames)[number]
export type CustomDateRange = `${number}-${number}`
export type DateRange = PredefinedDateRange | CustomDateRange

export const getDateRangeName = (range: PredefinedDateRange) => {
  return range.replace(/-/g, ' ')
}
export const predefinedDateRangeOptions = dateRangeNames.map(range => ({
  text: getDateRangeName(range),
  value: range,
}))
